import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Divider, Stack, TabPanel } from "@chakra-ui/react";
import AccountDetailsForm from "./account-details-form";
import PasswordForm from "./password-form";
const AccountPanel = props => {
    return (_jsx(TabPanel, Object.assign({}, props, { children: _jsxs(Stack, Object.assign({ spacing: "5", divider: _jsx(Divider, {}) }, { children: [_jsx(AccountDetailsForm, {}), _jsx(PasswordForm, {})] })) })));
};
export default AccountPanel;
